import { Injectable } from '@angular/core';
import { Vendor } from '../../entities/vendor';
import { localDb } from '../local-db.service';
import { BaseRepository } from './base.repository';

@Injectable({ providedIn: 'root' })
export class VendorRepository extends BaseRepository<Vendor, number> {
  constructor() {
    super(localDb.vendors, 'id');
  }
}
